module.exports = __webpack_public_path__ + "static/media/Gluten.9f08e6fa.png";